import { Component } from "@angular/core";

@Component({
  selector: "evrideo-live-other-user-entered",

  templateUrl: "./live-other-user-entered.component.html",
  styleUrl: "./live-other-user-entered.component.scss",
})
export class LiveOtherUserEnteredComponent {
  otherUsernameConnected: string;
  currentTime: Date = new Date();
  pageName: string = "the Live Page";
  constructor() {}
}
